<!-- <mat-toolbar color="primary" class="md-whiteframe-z2">
  <mat-toolbar-row>
    <div class="logo" style="padding-top: 2px">
      <img src="assets/images/logoWhiteLetters.png" height="50" />
    </div> 
    <span class="horizontal-spacer"></span>
    <ng-container *ngIf="oc_userAuthService.isShow()">
      <button
        mat-icon-button
        aria-label="Example icon-button with a menu"
        style="margin-right: 0.5%"
        (click)="fn_navigateToHome()"
      >
        <mat-icon>home</mat-icon>
      </button>
      <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        aria-label="Example icon-button with a menu"
      >
        <mat-icon>account_circle</mat-icon>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="fn_showAccountSetting()">
          <mat-icon>settings</mat-icon>
          <span>Configuración</span>
        </button>
        <button mat-menu-item (click)="fn_logout()">
          <mat-icon>send</mat-icon>
          <span>Cerrar Sesión</span>
        </button>
      </mat-menu>
    </ng-container>
  </mat-toolbar-row>
</mat-toolbar> -->


<div class="header">
  <img alt="logo" src="assets/images/logo-h.png" height="34" />
  
  <nav class="header-buttons" *ngIf="oc_userAuthService.isShow()">
    <button
      mat-icon-button
      aria-label="Example icon-button with a menu"
      style="margin-right: 0.5%"
      (click)="fn_navigateToHome()"
    >
      <mat-icon>home</mat-icon>
    </button>
    <button
      mat-icon-button
      [matMenuTriggerFor]="menu"
      aria-label="Example icon-button with a menu"
    >
      <mat-icon>account_circle</mat-icon>
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="fn_showAccountSetting()">
        <mat-icon>settings</mat-icon>
        <span>Configuración</span>
      </button>
      <button mat-menu-item (click)="fn_logout()">
        <mat-icon>send</mat-icon>
        <span>Cerrar Sesión</span>
      </button>
    </mat-menu>
  </nav>

</div>